var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration-g-assessments-grayscale"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-1458",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8388 35.7178C29.5376 44.8986 28.01 54.8044 28.01 54.8044L28.8014 78.0499L28.9565 94.5286C28.9565 94.5286 30.5256 120.96 30.5528 123.85L30.8916 147.465C31.038 156.831 35.5856 164.227 41.0689 163.951L127.286 161.173C132.751 161.03 137.137 153.379 137.107 144.009L136.054 32.229C135.888 22.8307 131.341 15.4675 125.877 15.7765L39.6408 18.5551C34.1753 18.6615 29.7892 26.3457 29.8388 35.7178Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1457",
    d: "M28.0778 61.9642C28.0772 61.8986 28.0766 61.833 28.076 61.7674C28.1349 55.0393 28.3772 48.3052 28.9254 41.5941C29.365 36.3302 30.0272 30.8951 31.9635 26.5673C34.1999 21.6392 37.407 19.518 41.5604 17.5632C45.8086 15.5637 49.0935 16.6642 52.8669 16.9364C69.7759 18.1961 86.7192 18.7658 103.645 17.4985C110.815 16.9722 118.002 16.0844 125.198 16.2135C130.926 16.2914 140.024 14.8827 142.489 25.5324C143.34 29.3111 143.317 33.446 143.274 37.4831C142.812 75.0336 142.372 112.616 141.93 150.166C141.899 153.35 141.769 156.799 140.445 159.139C139.021 161.58 134.644 162.082 134.644 162.082C134.644 162.082 70.6501 167.228 38.6332 169.834C37.6351 169.899 36.5962 169.966 35.6925 169.24C34.1102 167.88 33.6919 164.58 33.4609 161.7C32.375 148.118 31.289 134.537 30.4065 120.916",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1456",
    d: "M44.6066 85.5339L119.261 81.8751",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1455",
    d: "M77.8039 37.7037L115.202 35.4125",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1454",
    d: "M47.1821 101.887L102.646 103.191",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1453",
    d: "M97.5327 124.013L45.2294 124.803",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1452",
    d: "M96.8818 146.145L44.5785 146.934",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1451",
    d: "M118.134 57.6374L44.5786 60.3374",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1450",
    d: "M112.481 132.65C120.934 129.689 124.588 136.515 125.359 140.298C123.641 143.19 111.882 153.323 109.927 153.336C107.973 153.349 109.276 144.929 112.481 132.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1449",
    d: "M155.902 92.4196C156.172 91.9651 152.451 88.1925 150.556 86.363C149.489 84.4801 146.761 81.2084 144.395 83.1846C141.438 85.6549 130.202 104.151 126.407 110.542C123.37 115.655 115.781 127.542 112.366 132.846C113.785 136.09 117.669 142.489 121.855 142.132C127.088 141.686 128.467 135.684 130.102 132.429C131.737 129.173 155.565 92.9877 155.902 92.4196Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1448",
    d: "M113.251 134.028C114.553 136.74 118.198 142.1 122.364 141.839",
    stroke: "#70758F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1447",
    d: "M152.468 96.5692C151.472 97.3125 144.117 91.7732 139.891 88.7077C139.891 88.7077 139.712 88.6032 139.598 88.5337C148.571 76.0948 152.192 76.6743 156.54 82.2018C160.889 87.7294 153.714 95.6401 152.468 96.5692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1446",
    d: "M113.015 131.784C109.777 137.491 109.177 147.93 109.282 152.436C109.234 156.029 117.674 147.883 122.606 142.93C127.538 137.976 126.215 137.969 134.43 124.455C142.645 110.942 160.166 91.4947 156.234 82.1531C153.088 74.6798 147.45 78.4285 145.023 81.237C139.479 89.8815 116.252 126.077 113.015 131.784Z",
    stroke: "#70758F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1445",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.255 23.888C33.3621 19.3852 38.8091 15.3728 44.5363 11.8946C46.0804 10.7454 47.816 9.94646 49.6423 9.54423C51.7296 9.35797 53.818 9.88147 55.6265 11.0443C55.6265 11.0443 55.6991 11.0445 55.7196 11.1133C56.2065 11.3785 56.6829 11.678 57.1593 11.989C62.3367 15.4438 66.8955 20.499 68.8127 26.8494C69.1577 28.0162 69.417 29.2117 69.5881 30.4245C70.0439 33.9294 69.8288 37.5012 68.9567 40.9097C67.733 45.5104 65.6361 49.772 62.8053 53.4116C59.4927 58.0164 55.0242 61.4438 49.9578 63.2658C47.9794 63.9247 45.9265 64.2714 43.8603 64.2956C37.6314 64.3632 31.3397 61.843 25.8193 58.5014C24.7512 57.8717 23.7143 57.1798 22.7129 56.4286C20.8734 55.1392 19.2616 53.4921 17.956 51.5672C11.7646 41.7542 21.7647 29.9541 28.255 23.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1444",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2504 22.0304C48.4405 21.1403 52.9167 22.3653 56.253 25.0126C57.6029 26.083 58.7702 27.3886 59.6513 28.8708C61.6133 32.1693 62.2424 36.1687 61.7619 39.9759C61.2814 43.7831 59.7408 47.4069 57.6517 50.6264C56.0512 53.0926 54.0907 55.3754 51.6289 56.9833C49.1672 58.5912 46.1628 59.4827 43.2524 59.0621C40.7286 58.6976 38.4236 57.3832 36.4667 55.7487C32.1436 52.1374 29.2952 46.8362 28.5692 41.2504C28.0045 36.9043 28.7755 32.2285 31.4893 28.788C34.49 24.9837 39.2929 23.2458 43.8438 22.1236C43.9791 22.0903 44.1144 22.0592 44.2504 22.0304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1443",
    d: "M43.551 23.3936C33.4587 23.6309 25.4695 32.0052 25.7068 42.0975C25.936 51.8565 33.7928 59.7126 43.5518 59.9425C53.6449 59.9425 63.837 49.7141 63.837 39.6572C63.8281 30.3832 54.6192 23.3936 43.551 23.3936Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1442",
    d: "M42.3389 31.9676C42.3389 31.9676 42.4328 40.1859 42.4328 41.0331C42.4328 41.8803 42.4638 44.5779 43.5934 44.515C44.723 44.4522 52.0941 43.3854 52.0941 43.3854",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1441",
    d: "M140.59 89.7648C143.845 91.2837 150.68 94.8421 151.982 96.9251",
    stroke: "#70758F",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationGrey);
export default __webpack_public_path__ + "static/media/illustration-grey.c6f970e242ac0d8ba46928a0a819769e.svg";
export { ForwardRef as ReactComponent };